import { Button } from "@choose/ui/button";
import {
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  InputGroupInput,
} from "@choose/ui/input-group";
import { Separator } from "@choose/ui/separator";
import { createFileRoute, Link } from "@tanstack/react-router";
import { PlusIcon, SearchIcon, XIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { SnippetList } from "~/components/common/settings/snippets/snippet-list";
import { SnippetsFilters } from "~/components/common/settings/snippets/snippets-filters";
import { useSnippetsFilters } from "~/stores/snippets-store";

export const Route = createFileRoute(
  "/_auth/_app_shell/_settings-navigation/settings/snippets/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();
  const { filters, setFilters } = useSnippetsFilters();

  return (
    <>
      <title>{`${t("settings.snippets.title")} - ${t("app_name")}`}</title>
      <div className="bg-background w-full overflow-auto">
        <div className="m-auto max-w-2xl p-8">
          <header className="mt-14">
            <div className="flex flex-row items-end justify-between gap-4">
              <div>
                <h1 className="text-2xl">{t("settings.snippets.title")}</h1>
                <p className="text-muted-foreground mt-1 text-sm text-balance">
                  {t("settings.snippets.subtitle")}
                </p>
              </div>
              <div>
                <Button
                  type="button"
                  nativeButton={false}
                  render={
                    <Link to="/settings/snippets/add">
                      <PlusIcon />
                      {t("settings.snippets.add")}
                    </Link>
                  }
                />
              </div>
            </div>
          </header>
          <Separator className="my-8" />
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              <InputGroup>
                <InputGroupAddon align="inline-start">
                  <SearchIcon />
                </InputGroupAddon>

                <InputGroupInput
                  value={filters.search}
                  onChange={(e) =>
                    setFilters({ ...filters, search: e.target.value })
                  }
                  placeholder={t("settings.snippets.search.placeholder")}
                />
                {filters.search ? (
                  <InputGroupAddon align="inline-end">
                    <InputGroupButton
                      size="icon-xs"
                      onClick={() => setFilters({ ...filters, search: "" })}
                    >
                      <XIcon />
                    </InputGroupButton>
                  </InputGroupAddon>
                ) : null}
              </InputGroup>
              <SnippetsFilters filters={filters} onFiltersChange={setFilters} />
            </div>

            <SnippetList filters={filters} />
          </div>
        </div>
      </div>
    </>
  );
}
